import React from 'react';
import { BrainCircuit } from 'lucide-react';
import DataSection from '../dataSections/DataSection';

export default function Patents() {
  return (
    <DataSection
      title="Patents"
      icon={BrainCircuit}
      contentType="patent"
      executionUrlSuffix="patent"
    />
  );
}

